import { LOCALES } from 'i18n/locales';

export const observationsTabIntl = {
    [LOCALES.ENGLISH]: {
        'observationsTab.createObservation': 'Create Observation',
        'observationsTab.untitledObservation': 'Untitled Observation',
        'observationsTab.notes': 'Details',
        'observationsTab.category': 'Category',
        'observationsTab.noObservations': 'There are no observations in the drawn area.'
    },
    [LOCALES.WELSH]: {
        'observationsTab.createObservation': 'Creu Arsylwad',
        'observationsTab.untitledObservation': 'Arsylwad Dienw',
        'observationsTab.notes': 'Manylion',
        'observationsTab.category': 'Categori',
        'observationsTab.noObservations': 'Nid oes unrhyw sylwadau yn yr ardal wedi\'i lluniadu.'
    }
};
